import { ColumnConfig } from '@/components/table/Table';

export const companiesTableColumns: ColumnConfig[] = [
  { label: 'Nombre', field: 'name' },
  { label: 'Estado', field: 'status' },
];
